import Staking from "./Staking";

export default Staking;
